<template>
  <div
    v-if="
      this.$route.name !== 'Inbox ✉️' &&
      this.$route.name !== 'search' &&
      this.$route.name !== 'Items 📷' &&
      this.$route.name !== 'salesItemPurchase'
    "
    color="#F7F7F7"
    style="z-index: 1; background-color: #f7f7f7"
    id="footer"
  >
    <v-divider
      v-if="
        this.$route.name !== 'Inbox ✉️' &&
        this.$route.name !== 'search' &&
        this.$route.name !== 'Items 📷' &&
        this.$route.name !== 'salesItemPurchase'
      "
      style="border-width: 1px 0 0 0 !important"
      color="app"
    ></v-divider>

    <v-footer
      v-if="
        this.$route.name !== 'Inbox ✉️' &&
        this.$route.name !== 'search' &&
        this.$route.name !== 'Items 📷' &&
        this.$route.name !== 'salesItemPurchase'
      "
      style="z-index: 9"
      class="grey--text transparent md-6 text-center text-md-left"
      height="auto"
    >
      <v-col cols="12" md="4">
        <v-avatar height="150px" width="150px" class="mr-3">
          <v-img :src="require('@/assets/logos/logo1.svg')" contain />
        </v-avatar>

        <div class="subtitle-2 font-weight-light mb-0 mb-md-8">
          <span
            class="txt black--text"
            style="cursor: pointer"
            @click="downloadPDF()"
            >Terms and Conditions</span
          >
          |
          <span
            class="txt black--text"
            style="cursor: pointer"
            @click="downloadPPPDF()"
            >Privacy Policy</span
          >
        </div>
      </v-col>

      <v-col class="hidden-sm-and-down" cols="12" md="4">
        <div
          class="hidden-sm-and-down text-subtitle-1 font-weight-bold boss--text mb-6"
        >
          PAGES
        </div>
        <router-link
          class="hidden-sm-and-down body-1 font-weight-bold black--text d-block mb-4"
          to="/about"
          >About</router-link
        >
        <router-link
          class="hidden-sm-and-down body-1 font-weight-bold black--text d-block mb-4"
          to="/contact-us"
          >Contact</router-link
        >
      </v-col>

      <v-col
        :class="[$vuetify.breakpoint.mdAndUp ? 'mt-n12' : '']"
        cols="12"
        md="4"
      >
        <div
          class="hidden-md-and-down text-subtitle-1 font-weight-bold boss--text mb-6"
        >
          CONNECT
        </div>

        <v-btn
          href="https://www.facebook.com/strappRSA"
          rel="noopener"
          target="_blank"
          :x-small="$vuetify.breakpoint.smAndDown"
          fab
          small
          color="app"
          class="social-icon social-icon--facebook ml-0"
        >
          <v-icon color="white">mdi-facebook</v-icon>
          <div class="tooltip">Facebook</div>
        </v-btn>
        <v-btn
          fab
          small
          href="https://www.linkedin.com/company/strapp-rsa/"
          color="app"
          rel="noopener"
          target="_blank"
          :x-small="$vuetify.breakpoint.smAndDown"
          class="social-icon social-icon--linkedin ml-3"
        >
          <v-icon color="white">mdi-linkedin</v-icon>
          <div class="tooltip">LinkedIn</div>
        </v-btn>
        <v-btn
          href="https://www.instagram.com/strapprsa/"
          rel="noopener"
          target="_blank"
          :x-small="$vuetify.breakpoint.smAndDown"
          fab
          small
          color="app"
          class="social-icon social-icon--instagram ml-3"
        >
          <v-icon color="white">mdi-instagram</v-icon>
          <div class="tooltip">Instagram</div>
        </v-btn>
        <v-btn
          href="https://www.strapp.co.za/"
          rel="noopener"
          target="_blank"
          :x-small="$vuetify.breakpoint.smAndDown"
          fab
          small
          color="app"
          class="ml-3 social-icon social-icon--linkedin"
        >
          <v-icon color="white">mdi-web</v-icon>
          <div class="tooltip">Website</div>
        </v-btn>
      </v-col>
    </v-footer>

    <div class="py-5 text-center">
      <v-divider
        class="mx-16"
        style="border-width: 1px 0 0 0 !important; opacity: 0.6"
        height="20px"
        color="grey"
      ></v-divider>
      <div class="text-center caption mt-3">
        © Strapp (t/a K2020193617) {{ new Date().getFullYear() }} . All Rights
        Reserved
      </div>
    </div>

    <v-overlay :value="ShowPDFClicked" z-index="12">
      <div clas="grid pa-12">
        <v-row
          ><v-col cols="11">
            <iframe
              v-if="ShowPDFClicked"
              src="/static/Strapp Terms and Conditions 2023.pdf"
              :height="[$vuetify.breakpoint.smAndUp ? '700' : '400']"
              :width="[$vuetify.breakpoint.smAndUp ? '900' : '250']"
            />
          </v-col>
          <v-col cols="1">
            <v-btn fab class="accent" icon @click="ShowPDFClicked = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col></v-row
        >
      </div>
    </v-overlay>
    <v-overlay :value="ShowPPPDFClicked" z-index="12">
      <div clas="grid pa-12">
        <v-row
          ><v-col cols="11">
            <iframe
              v-if="ShowPPPDFClicked"
              src="/static/Strapp Privacy Policy 2023.pdf"
              :height="[$vuetify.breakpoint.smAndUp ? '700' : '400']"
              :width="[$vuetify.breakpoint.smAndUp ? '900' : '250']"
            />
          </v-col>
          <v-col cols="1">
            <v-btn fab class="accent" icon @click="ShowPPPDFClicked = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col></v-row
        >
      </div>
    </v-overlay>
  </div>
</template>

<script>
export default {
  name: "CoreFooter",

  data: () => ({
    ShowPDFClicked: false,
    ShowPPPDFClicked: false,
    socials: [
      { icon: "mdi-facebook", href: "https://www.facebook.com/strappRSA" },
      // { icon: 'mdi-twitter', href: '#' },
      { icon: "mdi-instagram", href: "https://www.instagram.com/strapprsa/" },
      // { icon: 'mdi-email', href: 'mailto:strapp.info@gmail.com' },
      // {
      //   icon: 'mdi-linkedin',
      //   href: 'https://www.linkedin.com/company/strapp-rsa/'
      // },
      // { icon: 'mdi-email', href: '#' },
      // { icon: 'fab fa-tiktok', href: '#' },
      // { icon: 'mdi-youtube', href: '#' },
      { icon: "mdi-web", href: "https://www.strapp.co.za/" },
    ],
  }),

  methods: {
    downloadPDF() {
      const pdfUrl = "/static/Strapp Terms and Conditions 2023.pdf"; // Replace with your actual PDF URL
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.target = "_blank";
      link.download = "Strapp Terms and Conditions 2023.pdf"; // You can set the desired filename here
      link.click();
    },
    downloadPPPDF() {
      const pdfUrl = "/static/Strapp Privacy Policy 2023.pdf"; // Replace with your actual PDF URL
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.target = "_blank";
      link.download = "Strapp Privacy Policy 2023.pdf"; // You can set the desired filename here
      link.click();
    },
  },

  computed: {
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "1000px";
        case "sm":
          return "1000px";
        case "md":
          return "1000px";
        case "lg":
          return "800px";
        case "xl":
          return "1000px";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.txt:hover {
  text-decoration: underline;
  font-weight: bold;
}

/* Color Variables */
$color-instagram: linear-gradient(to top, #cc208e 0%, #6713d2 100%);
$color-linkedin: linear-gradient(to top, #cc208e 0%, #6713d2 100%);
$color-facebook: linear-gradient(to top, #cc208e 0%, #6713d2 100%);

/* Social Icon Mixin */
@mixin social-icon($color) {
  background: $color;
  color: #fff;

  .tooltip {
    background: $color;
    color: currentColor;

    &:after {
      border-top-color: $color;
    }
  }
}

/* Social Icons */

.social-icon {
  cursor: pointer;
  font-size: 2.5rem;
  text-decoration: none;
  transition: all 0.15s ease;

  &:hover {
    color: #fff;

    .tooltip {
      visibility: visible;
      opacity: 1;
      transform: translate(-50%, -150%);
    }
  }

  &:active {
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.5) inset;
  }

  &--linkedin {
    @include social-icon(#b22af0);
  }
  &--facebook {
    @include social-icon(#b22af0);
  }
  &--instagram {
    @include social-icon(#b22af0);
  }
}

/* Tooltips */
.tooltip {
  display: block;
  position: absolute;
  top: 0;
  left: 50%;
  padding: 0.8rem 1rem;
  border-radius: 40px;
  font-size: 0.8rem;
  font-weight: bold;
  opacity: 0;
  pointer-events: none;
  text-transform: uppercase;
  transform: translate(-50%, -100%);
  transition: all 0.3s ease;
  z-index: 1;

  &:after {
    display: block;
    position: absolute;
    bottom: 1px;
    left: 50%;
    width: 0;
    height: 0;
    content: "";
    border: solid;
    border-width: 10px 10px 0 10px;
    border-color: transparent;
    transform: translate(-50%, 100%);
  }
}
</style>

<style lang="sass">
#footer

  a
    text-decoration: none

  img
    position: absolute
    bottom: 0
    right: 0
    left: 0
    height: 300px

  @media screen and (min-width: 960px)
    margin-top: 0px
</style>
